import { ModelEventDto } from '@careapp-group/ng-sdk';
import { CaEntityReducer } from '../entity-state/entity-reducer';
import { BaseFilterType } from '../entity-state/entity-actions-factory';
import { Events } from './events.actions';

export class EventsReducer extends CaEntityReducer<ModelEventDto, BaseFilterType> {}

export const state = new EventsReducer(Events);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
